<template>
  <v-container class="pa-0">
    <v-app-bar color="transparent" class="elevation-0 pa-0 page-header-toolbar">
      <page-header-title :title="page_title"></page-header-title>

      <v-spacer></v-spacer>

      <action-button type="cancel" @click="$emit('return_modal_cancel_view')" v-if="modal == true" />
      <action-button type="back" @click="$router.go(-1)" v-if="modal != true" />

      <router-link :to="{ path: BACKEND_URL + '/tasks/edit/' + task.id, props: { id: task.id } }" v-if="$can('task-edit') && modal != true">
        <action-button type="edit" />
      </router-link>

      <action-button type="delete" @click="del(task.id)" v-if="$can('task-delete') && modal != true" />
    </v-app-bar>

    <v-form ref="form">
      <v-container grid-list-md>
        <v-card>
          <v-card-text class="pa-4">
            <v-layout row wrap>
              <v-flex lg3 md4 sm6 xs12>
                <v-text-field
                  name="task.title"
                  v-model="task.title"
                  :label="$t('tasks.name')"
                  readonly
                  autocomplete="new-password"
                ></v-text-field>
              </v-flex>
              <v-flex lg3 md4 sm6 xs12>
                <v-text-field
                  name="task.place"
                  v-model="task.place"
                  :label="$t('tasks.place')"
                  readonly
                  autocomplete="new-password"
                ></v-text-field>
              </v-flex>
              <v-flex lg3 md4 sm6 xs12>
                <v-text-field
                  name="task.instructor_id"
                  v-model="task.instructor.fullname"
                  :label="$t('tasks.instructor_id')"
                  readonly
                  autocomplete="new-password"
                ></v-text-field>
              </v-flex>
              <v-flex lg3 md4 sm6 xs12>
                <v-text-field
                  name="task.start_date"
                  :value="computedTaskStartDate"
                  :label="$t('tasks.start_date')"
                  readonly
                  autocomplete="new-password"
                ></v-text-field>
              </v-flex>
              <v-flex lg3 md4 sm6 xs12>
                <v-text-field
                  name="task.start_time"
                  :value="computedTaskStartTime"
                  :label="$t('tasks.start_time')"
                  readonly
                  autocomplete="new-password"
                ></v-text-field>
              </v-flex>
              <v-flex lg3 md4 sm6 xs12>
                <v-text-field
                  name="task.end_date"
                  :value="computedTaskEndDate"
                  :label="$t('tasks.end_date')"
                  readonly
                  autocomplete="new-password"
                ></v-text-field>
              </v-flex>
              <v-flex lg3 md4 sm6 xs12>
                <v-text-field
                  name="task.end_time"
                  :value="computedTaskEndTime"
                  :label="$t('tasks.end_time')"
                  readonly
                  autocomplete="new-password"
                ></v-text-field>
              </v-flex>
              <v-flex lg3 md4 sm6 xs12>
                <v-text-field
                  name="task.status"
                  :value="this.$dd_task_status(task.status)"
                  :label="$t('tasks.status')"
                  readonly
                  autocomplete="new-password"
                ></v-text-field>
              </v-flex>
              <v-flex xs12>
                <v-textarea name="task.description" v-model="task.description" :label="$t('tasks.description')" readonly></v-textarea>
              </v-flex>
            </v-layout>
          </v-card-text>
        </v-card>
      </v-container>
    </v-form>
  </v-container>
</template>

<script>
export default {
  name: "TaskView",

  props: ["id", "modal"],

  data() {
    return {
      page_title: "",
      task: {}
    }
  },

  computed: {
    computedTaskStartDate() {
      return this.task.start_date ? this.moment.utc(this.task.start_date).format(this.DATE_FORMAT) : ""
    },
    computedTaskStartTime() {
      return this.task.start_time ? this.moment.utc(this.task.start_time, this.TIME_FORMAT).format(this.TIME_FORMAT) : ""
    },
    computedTaskEndDate() {
      return this.task.end_date ? this.moment.utc(this.task.end_date).format(this.DATE_FORMAT) : ""
    },
    computedTaskEndTime() {
      return this.task.end_time ? this.moment.utc(this.task.end_time, this.TIME_FORMAT).format(this.TIME_FORMAT) : ""
    }
  },

  created() {
    axios
      .get(this.API_URL + "task/" + this.id)
      .then((res) => {
        this.task = res.data.data
        this.page_title = this.$t("tasks.view_task", { name: this.task.title })
      })
      .catch((err) => console.log(err))
  },

  methods: {
    del(id) {
      let vm = this

      this.$awn.confirm(
        this.$t("global.delete_message"),
        () => {
          return
        },
        () => {
          axios
            .delete(this.API_URL + "task/" + id)
            .then((res) => {
              vm.$router.push(this.BACKEND_URL + "/tasks")
              vm.$awn.success(vm.$t("global.delete_success"))
            })
            .catch((err) => console.log(err))
        },
        {
          labels: {
            confirm: "",
            confirmCancel: this.$t("global.yes"),
            confirmOk: this.$t("global.no")
          }
        }
      )
    }
  }
}
</script>

<style scoped></style>
